import { observer } from 'mobx-react';
import { FC, ReactElement } from 'react';

// Dashboard step 2
const DashboardDetailsGraph: FC = observer((): ReactElement => {
  return <div className="d-flex flex-1"></div>;
});

export default DashboardDetailsGraph;
